import { Box } from "@mui/material";
import React, { useState } from "react";
import { MilestoneTask } from "../../../../../../api/homeSiteMilestones/types";
import AdditionalActionsDetails from "./ActionDetailsComponents/AdditionalActionsDetails";
import { Note } from "../../../../../../api/homeSiteNotes/types";
import { Exception } from "../../../../../../api/homeSiteExceptions/types";
import { Alert } from "../../../../../../api/homeSiteAlerts/types";
import { GlobalSnackNotify } from "../../../../../../components/globalSnackNotify/globalSnackNotify";
import { DivisionMileStone } from "../../../../../../api/divisionMileStones/types";
import { MilestoneComponent } from "./ActionDetailsComponents/MileStone";

interface BasicActionsDetailsProps {
  userId: string;
  homeSiteId: string;
  milestoneTasks: MilestoneTask[];
  milestoneState: DivisionMileStone[];
  notesState: Note[];
  exceptionsState: Exception[];
  alertState: Alert[];
  tab?: string;
  updateMilestoneTasks: (data: any) => void;
  divisionCode: string;
  conciergeEmail: string;
  saleDate: string | null | undefined;
  closeOfEscrowActual: string | null | undefined;
  closeOfEscrowEstimated: string | null | undefined;
  milestoneFilter?: string;
  expandMilestone?: string;
  opportunityId: string;

  isDirty?: (dirty: boolean) => void;
  setChildHandlers?: (handlers: {
    save: () => Promise<void>;
    cancel: () => void;
  }) => void;
  setMilestoneTab?: (tab: string) => void;
  milestoneTab?: string;
}

const BasicActionsDetails: React.FC<BasicActionsDetailsProps> = ({
  milestoneTasks,
  milestoneState,
  notesState,
  exceptionsState,
  alertState,
  homeSiteId,
  userId,
  tab,
  updateMilestoneTasks,
  divisionCode,
  conciergeEmail,
  milestoneFilter,
  expandMilestone,
  opportunityId,
  isDirty,
  setChildHandlers,
  saleDate,
  closeOfEscrowEstimated,
  closeOfEscrowActual,
  setMilestoneTab,
  milestoneTab,
}) => {
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success" as "success" | "error" | "info",
  });

  const showSnackbar = (
    message: string,
    severity: "success" | "error" | "info"
  ) => {
    setNotification({ open: true, message, severity });
  };
  return (
    <Box
      sx={{
        width: "1020px",
        height: "564px",
        display: "flex",
        gap: "16px",
        justifyContent: "flex-start",
        alignItems: "flex-start",
      }}
    >
      {/* Milestone Section */}
      <Box
        sx={{
          flex: "1 1 auto",
          width: "500px",
          height: "564px",
          display: "flex",
          borderRadius: "4px",
          gap: "16px",
        }}
      >
        <MilestoneComponent
          homeSiteId={homeSiteId}
          notesCount={notesState}
          alertsCount={alertState}
          exceptionCount={exceptionsState}
          userId={userId}
          updateMilestoneTasks={updateMilestoneTasks}
          milestoneName={expandMilestone || milestoneFilter}
          saleDate={saleDate}
          closeOfEscrowActual={closeOfEscrowActual}
          closeOfEscrowEstimated={closeOfEscrowEstimated}
          setMilestoneTab={setMilestoneTab}
        />
      </Box>

      {/* Additional Actions Section */}
      <Box
        sx={{
          flex: "1 1 auto",
          width: "504px",
          height: "564px",
          display: "flex",
          borderRadius: "4px",
        }}
      >
        <AdditionalActionsDetails
          userId={userId}
          homeSiteId={homeSiteId}
          notesState={notesState}
          exceptionsState={exceptionsState}
          alertState={alertState}
          mileStones={milestoneState}
          tab={milestoneTab}
          divisionCode={divisionCode}
          conciergeEmail={conciergeEmail}
          opportunityId={opportunityId}
          milestoneFilter={milestoneFilter}
          isDirty={isDirty}
          setChildHandlers={setChildHandlers}
          showSnackbar={showSnackbar}
        />
      </Box>
      {/* Basic Detail Section */}
      <Box
        sx={{
          width: "1020px",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginBottom: "50px",
        }}
      >
        <GlobalSnackNotify
          open={notification.open}
          onClose={() => setNotification({ ...notification, open: false })}
          message={notification.message}
          severity={notification.severity}
          style={{
            position: "absolute",
            left: "20px",
            transform: "translateY(10px)",
          }}
        />
      </Box>
    </Box>
  );
};

export default BasicActionsDetails;